import ComplitedMonitoringContent from "./ComplitedMonitoringContent/ComplitedMonitoringContent"
import classes from './ComplitedMonitoring.module.scss'

const ComplitedMonitorind = () => {

    return (
        <div className={classes.monitoringContainer}>
                <ComplitedMonitoringContent/>
        </div>
    )
}

export default ComplitedMonitorind